import React, { useEffect, useState } from "react";
import { fetchUpcomingEventsList } from "../../../redux/actions";
import { connect } from "react-redux";
import { format } from "date-fns";
import { token } from "../../../modules/auth";
import { Link } from "react-router-dom";
import * as CORPORATE_ROUTES from "../../../Router/corporate_routes";
import { ButtonPrimary } from "../../Button";
import { formatDate } from "../../../modules/dates";
import Loading from "../../Loading";
import { BOOKED_EVENT_STATUS } from "../../../constants";

const AgencyDashUpcomingEvents = ({
  token,
  fetchUpcomingEventsList,
  upcomingEvents,
  isFetchingUpcomingEvents,
  agencies = [],
}) => {
  const [showAll, setShowAll] = useState(false);
  const today = new Date();
  const addDays = days => {
    const currentDate = new Date();
    return new Date(currentDate.getTime() + days * 24 * 60 * 60 * 1000);
  };
  let queryParams = {
    per_page: 5,
    managedEvents: true,
    eventDate: `${format(new Date(), "YYYY-MM-DD 00:00:00")},${format(
      addDays(180),
      "YYYY-MM-DD 23:59:59"
    )}`,
    eventStatus: `${BOOKED_EVENT_STATUS.CONFIRMED},${BOOKED_EVENT_STATUS.PENDING_INVOICE},${BOOKED_EVENT_STATUS.COMPLETED}`,
    orderBy: "edge_event.event_date_from",
    orderByDirection: "asc",
  };

  useEffect(() => {
    if (agencies.length > 0) {
      queryParams.agency = agencies.map(a => a.id).join(",");
    }
    fetchUpcomingEventsList(token, 1, queryParams);
  }, [agencies]);

  const eventsList = Array.isArray(upcomingEvents) ? upcomingEvents : [];
  const sortedEvents = [...eventsList].sort(
    (a, b) =>
      new Date(a?.data?.event_date_from) - new Date(b?.data?.event_date_from)
  );

  const visibleEvents = showAll ? sortedEvents : sortedEvents.slice(0, 8);

  return (
    <div key={`agencyUpcomingEvents-${agencies?.length || 1}`}>
      <h2 className="text-2xl font-bold pb-2">My Forthcoming Events</h2>
      {isFetchingUpcomingEvents ? (
        <div className="relative" style={{ height: 650 }}>
          <div
            className="absolute pin"
            style={{
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Loading />
          </div>
        </div>
      ) : visibleEvents.length > 0 ? (
        <>
          {visibleEvents.map((bookedEvent, index) => {
            let companyName = bookedEvent.data.company.name || "";
            return (
              <div
                key={index}
                className="flex flex-row items-center border-t border-grey py-1"
              >
                <div className="block w-full">
                  <div className="flex flex-col mb-1 p-2 h-full">
                    <h4 className="mt-1 mb-1 opacity-75 font-bold">
                      {formatDate(
                        bookedEvent.data.event_date_from,
                        "DD/MM/YYYY"
                      )}{" "}
                      - {companyName}
                    </h4>
                    <h4 className="mt-1 mb-1 text-xl">
                      <Link
                        className="text-black"
                        to={CORPORATE_ROUTES.FRONTEND.BOOKED_EVENTS.SINGLE.replace(
                          ":slug",
                          bookedEvent.data.id
                        )}
                      >
                        <span title="Manage event">
                          {bookedEvent.data.enquiry.event_name}
                        </span>
                      </Link>
                    </h4>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <div className="bg-light-blue text-center p-4 border-light-grey border mt-8 h-full">
          <p className="font-bold mt-4">
            You currently have no confirmed events assigned to you over the next
            3 months.
          </p>
        </div>
      )}
      <div className="text-center mt-4">
        <Link to={CORPORATE_ROUTES.FRONTEND.BOOKED_EVENTS.ALL}>
          <ButtonPrimary>View all Events</ButtonPrimary>
        </Link>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: token(state),
    ...state.bookedEvents,
  };
};

const mapDispatchToProps = {
  fetchUpcomingEventsList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgencyDashUpcomingEvents);
